import { configureStore } from '@reduxjs/toolkit';
import addFromGoalLibrarySlice from './slice/addFromGoalLibrary/addFromGoalLibrarySlice';
import addFromLibrarySlice from './slice/addFromLibrary/addFromLibrarySlice';
import appointmentSlice from './slice/appointment/appointmentSlice';
import authorization from './slice/Authorizations/authorization';
import clientInsuranceSlice from './slice/ClientInsurance/ClientInsurance';
import clientIntakeDetails from './slice/ClientIntakeDetails/clientIntakeDetails';
import getComment from './slice/Comments/getComments';
import createDomain from './slice/CreateDomain/createDomain';
import createProgram from './slice/CreateProgram/createProgram';
import EditDefaultRate from './slice/DefaultRate/getDefaultRateById';
import editAuthorizationCode from './slice/EditAuthorizationCode/editAuthorizationCode';
import metaDataAuthorization from './slice/EditAuthorizationCode/getMetaData';
import editDomain from './slice/EditDomain/editDomain';
import editProgram from './slice/EditProgram/editProgram';
import EditRoleCallReducer from './slice/EditRole/getRoleById';
import feeScheduleSlice from './slice/FeeSchedule/getFeeSchedule';
import getAllRoles from './slice/GetAllRoles/getAllRolesSlice';
import getAppointmentDetails from './slice/GetAppointmentDetails/getAppointmentdetails';
import getClientDocument from './slice/GetClientDocument/getClientDocument';
import getAllClientInquiryDetailsCall from './slice/GetClientInquiryDetails/getClientInquiryDetails';
import getAllDocument from './slice/GetDocumentById/getAllDocument';
import getDomainById from './slice/GetDomainById/getDomainById';
import getEmployeeById from './slice/GetEmployeeById/getEmployeeById';
import getFiles from './slice/GetFiles/getFiles';
import getMasteryCriteriaTemplate from './slice/GetMasterCriteriaTemplate/getMasteryCriteriaTemplate';
import getMasteryCriteriaTemplateById from './slice/GetMasteryCriteriaTemplateById/getMasteryCriteriaTemplateById';
import getProgramBookDataById from './slice/GetProgramBookDataById/getProgramBookDataById';
import getProgramsByDomainId from './slice/GetProgramsByDomainId/getProgramsByDomainId';
import getTarget from './slice/getTarget/getTargetByProgramId';
import getTemplate from './slice/GetTemplate/getTemplate';
import getUserByOrganiationId from './slice/getUser/getUserByOrganizationId';
import getUserPermission from './slice/getUserPermission/getUserPermissionSlice';
import GoalLibrarySlice from './slice/GoalLibrary/GoalLibraryData';
import groupSlice from './slice/Group/groupSlice';
import insurance from './slice/Insurance/insurance';
import intakeEditorSlice from './slice/IntakeEditor/intakeEditor';
import allShotTermGoalSlice from './slice/Intervention/AllNotShortTermGoals';
import allDiagnosisCodesSlice from './slice/Intervention/DiagnosisCodeData';
import getDomainsByType from './slice/Intervention/DomainsByUserType';
import getPhasesForIntervention from './slice/Intervention/getAllPhasesForIntervention';
import getShortTermGoalSlice from './slice/Intervention/getShortTermGoalById';
import allInProgressGoals from './slice/Intervention/InProgressShortTermLongTerm';
import LongTermGoalByUserTypeSlice from './slice/Intervention/LongTermGoalsByUserType';
import InterventionSlice from './slice/InterventionAll/InterventionSlice';
import loginReducer from './slice/login/loginSlice';
import saveMasterCriteria from './slice/MasterCriteriaSave/masterCriteriaSave';
import mergeClaims from './slice/MergeClaims/mergeClaims';
import metaData from './slice/MetaDataManagement/metaData';
import getMine from './slice/MineSlice/getMine';
import getActiveAsyncHistoryReducer from './slice/MineSlice/getOtherGridData';
import notifications from './slice/Notification/notifications';
import organization from './slice/organizationName/organization';
import organizationByIdSliceReducer from './slice/organizations/organizationByIdSlice';
import programBookForUserSlice from './slice/ProgramBookByUserChildID/programBookByUserChildID';
import programBookLibrarySlice from './slice/programBookLibrary/programBookLibrarySlice';
import saveProgramBookLibraryDomainFolderData from './slice/ProgramBookLibrarySlice/getProgramBookDomainFolderByUUID';
import saveProgramBookLibraryDataByID from './slice/ProgramBookLibrarySlice/getProgramBookLibraryDataById';
import saveProgramBookLibrary from './slice/ProgramBookLibrarySlice/saveProgramBookLibrarySlice';
import savePhaseForProgram from './slice/programPhase/getPhaseForProgram';
import questionBankManementSlice from './slice/questionBankManement/questionBankManementSlice';
import quickLook from './slice/QuickLook/quickLook';
import customRateSlice from './slice/Rate/customRateSlice';
import renameProgramEntity from './slice/RenameEntity/index';
import renameProgram from './slice/RenameProgram/renameProgram';
import runSessionSlice from './slice/runSession/runSessionSlice';
import saveDocument from './slice/SaveClientDocument/saveClientDcument';
import getPhaseReducer from './slice/SavePhase/getPhaseReducer';
import getStatusReducer from './slice/SaveStatus/getStatusReducer';
import addTarget from './slice/saveTarget/saveTarget';
import getServices from './slice/Scheduling/getServices';
import schedulingSlice from './slice/SchedulingRedux/Scheduling';
import servicePlacesSlice from './slice/ServicePlaces/getAllServicePlaces';
import serviceTypeByInterventionSlice from './slice/ServiceTypeByInterventionType/serviceTypeByIntervention';
import sessionSlice from './slice/session/sessionSlice';
import SignatureRedex from './slice/Signature/Signature';
import CosignatureSlice from './slice/Cosignature/Cosignature';
import templateReducer from './slice/template/templateSlice';
import userAccount from './slice/UserAccount/UserAccount';
import userDashboard from './slice/UserDashboardData/userDashboard';
import userDetailsSlice from './slice/userDetails/userDetailsSlice';
import userProfileDataSlice from './slice/UserProfileData/userProfileDataSlice';
import usersSlice from './slice/users/usersSlice';
import ViewOnly from './slice/ViewOnlyComponent/ViewOnly';
import getInterventionAssignToo from '../redux/slice/Intervention/getAllAssign';
import getLongForm from '../redux/slice/getLongForm/getLongForm';
export const store = configureStore({
    reducer: {
        questionBankManementSlice: questionBankManementSlice,
        getHistory: getActiveAsyncHistoryReducer,
        GoalLibrarySlice: GoalLibrarySlice,
        interventionSlice: InterventionSlice,
        allDiagnosisCodesSlice: allDiagnosisCodesSlice,
        login: loginReducer,
        getMine: getMine,
        getDomainById: getDomainById,
        getProgramsByDomainId: getProgramsByDomainId,
        createDomain: createDomain,
        createProgram: createProgram,
        notifications: notifications,
        getFiles: getFiles,
        editDomain: editDomain,
        template: templateReducer,
        renameProgram: renameProgram,
        editProgram: editProgram,
        getAllDocument: getAllDocument,
        saveDocument: saveDocument,
        getClientDocument: getClientDocument,
        getProgramBookDataById: getProgramBookDataById,
        getAllClientInquiryDetailsCall: getAllClientInquiryDetailsCall,
        saveProgramBookLibrary: saveProgramBookLibrary,
        saveMasterCriteria: saveMasterCriteria,
        getMasteryCriteriaTemplate: getMasteryCriteriaTemplate,
        getMasteryCriteriaTemplateById: getMasteryCriteriaTemplateById,
        saveProgramBookLibraryDomainFolderData:
            saveProgramBookLibraryDomainFolderData,
        clientIntakeDetails: clientIntakeDetails,
        saveProgramBookLibraryDataByID: saveProgramBookLibraryDataByID,
        addTarget: addTarget,
        getTemplate: getTemplate,
        users: usersSlice,
        getTarget: getTarget,
        getUser: getUserByOrganiationId,
        session: sessionSlice,
        runSession: runSessionSlice,
        getPhaseReducer: getPhaseReducer,
        getStatusReducer: getStatusReducer,
        userProfileData: userProfileDataSlice,
        getUserPermission: getUserPermission,
        getComment: getComment,
        programBookLibraries: programBookLibrarySlice,
        addFromLibrary: addFromLibrarySlice,
        scheduling: schedulingSlice,
        getAllRoles: getAllRoles,
        getServices: getServices,
        ViewOnly: ViewOnly,
        appointment: appointmentSlice,
        SignatureRedex: SignatureRedex,
        CosignatureSlice: CosignatureSlice,
        renameProgramEntity: renameProgramEntity,
        savePhaseForProgram: savePhaseForProgram,
        organizationByIdSlice: organizationByIdSliceReducer,
        EditRole: EditRoleCallReducer,
        programBookForUser: programBookForUserSlice,
        groupOfEmployee: groupSlice,
        getEmployeeById: getEmployeeById,
        editAuthorizationCode: editAuthorizationCode,
        metaDataAuthorization: metaDataAuthorization,
        serviceTypeByInterventionType: serviceTypeByInterventionSlice,
        servicePlacesSlice: servicePlacesSlice,
        getShortTermGoalById: getShortTermGoalSlice,
        interventionPhases: getPhasesForIntervention,
        getInterventionAssignToo: getInterventionAssignToo,
        DomainsByUserType: getDomainsByType,
        allInProgressGoals: allInProgressGoals,
        feeSchedule: feeScheduleSlice,
        allNotInprogressGoals: allShotTermGoalSlice,
        customRateSlice: customRateSlice,
        LongTermGoalByUserType: LongTermGoalByUserTypeSlice,
        insurance: insurance,
        authorization: authorization,
        clientInsurance: clientInsuranceSlice,
        quickLook: quickLook,
        EditDefaultRate: EditDefaultRate,
        addFromGoalLibraries: addFromGoalLibrarySlice,
        metaData: metaData,
        userDashboard: userDashboard,
        userDetails: userDetailsSlice,
        mergeClaims: mergeClaims,
        organization: organization,
        intakeEditor: intakeEditorSlice,
        userAccount: userAccount,
        getAppointmentDetails: getAppointmentDetails,
        getLongForm: getLongForm,
    },
});
export type IRootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
